export interface User {
	id: string;
	username: string;
	displayName: string;
	avatar: string;
	bio: string;
	joinedAt: string;
	reputation: number;
	totalSwaps: number;
	successfulSwaps: number;
	ratings: Rating[];
}

export interface Rating {
	id: string;
	fromUserId: string;
	fromUsername: string;
	score: number; // 1-5
	comment: string;
	swapId: string;
	createdAt: string;
}

export interface Item {
	id: string;
	ownerId: string;
	ownerUsername: string;
	title: string;
	description: string;
	category: ItemCategory;
	condition: ItemCondition;
	estimatedValue: number;
	images: string[];
	tags: string[];
	createdAt: string;
	available: boolean;
	wantedCategories: ItemCategory[];
}

export type ItemCategory =
	| "electronics"
	| "clothing"
	| "books"
	| "furniture"
	| "sports"
	| "games"
	| "music"
	| "art"
	| "tools"
	| "kitchen"
	| "outdoor"
	| "collectibles"
	| "other";

export type ItemCondition =
	| "new"
	| "like-new"
	| "good"
	| "fair"
	| "worn";

export interface SwapProposal {
	id: string;
	fromUserId: string;
	fromUsername: string;
	toUserId: string;
	toUsername: string;
	offeredItems: string[]; // item IDs
	requestedItems: string[]; // item IDs
	message: string;
	fairnessScore: number;
	status: SwapStatus;
	createdAt: string;
	updatedAt: string;
	counterProposalId?: string;
}

export type SwapStatus =
	| "pending"
	| "accepted"
	| "declined"
	| "countered"
	| "completed"
	| "cancelled";

export const CATEGORY_LABELS: Record<ItemCategory, string> = {
	electronics: "Electronics",
	clothing: "Clothing & Apparel",
	books: "Books & Media",
	furniture: "Furniture & Home",
	sports: "Sports & Fitness",
	games: "Games & Toys",
	music: "Musical Instruments",
	art: "Art & Crafts",
	tools: "Tools & Hardware",
	kitchen: "Kitchen & Dining",
	outdoor: "Outdoor & Garden",
	collectibles: "Collectibles",
	other: "Other",
};

export const CONDITION_LABELS: Record<ItemCondition, string> = {
	new: "New",
	"like-new": "Like New",
	good: "Good",
	fair: "Fair",
	worn: "Worn",
};

export const CATEGORY_ICONS: Record<ItemCategory, string> = {
	electronics: "Cpu",
	clothing: "Shirt",
	books: "BookOpen",
	furniture: "Sofa",
	sports: "Dumbbell",
	games: "Gamepad2",
	music: "Music",
	art: "Palette",
	tools: "Wrench",
	kitchen: "ChefHat",
	outdoor: "Trees",
	collectibles: "Gem",
	other: "Package",
};
